import { computed } from 'vue';
import { LastWithdrawalQuery, WithdrawalItem } from '@libs/api-reference';
import { useUser } from '@core/user';
import { useLiveInfiniteQueryV2 } from '@libs/use';
import { CODES } from '@libs/use';

import * as API from '../requests';
import { createWithdrawalChannelName } from '../utils/socket';
import { transformWithdrawalChange } from '../utils/transform';
import { CASH_QUERY_KEYS } from '../constants';

export default function useGetWithdrawalInfiniteLiveQuery() {
  const { user, onUserReady } = useUser();

  const {
    result,
    execute,
    isPending: isLoadingLastWithdrawals,
    isRevalidating: isRevalidatingWithdrawals,
    ...query
  } = useLiveInfiniteQueryV2<LastWithdrawalQuery, WithdrawalItem>({
    fetcher: API.getLastWithdrawals,
    key: CASH_QUERY_KEYS.withdrawals,
    unsubscribe: false,
    getChannels() {
      return [createWithdrawalChannelName(user.value?.userId)];
    },
    onUpdate(signal) {
      const actions = {
        [CODES.WithdrawalChangeStateSignal]: transformWithdrawalChange,
      };

      if (actions[signal.code]) {
        const data = actions[signal.code](signal.data);

        const index = result.value.findIndex(
          (withdrawal) => withdrawal.requestId === data.requestId
        );

        if (index > -1) {
          Object.assign(result.value[index], data);
        }
      }
    },
  });

  onUserReady(execute);

  const withdrawals = computed<WithdrawalItem[]>(() => result.value || []);

  return {
    withdrawals,
    isLoadingLastWithdrawals,
    isRevalidatingWithdrawals,
    execute,
    ...query,
  };
}
